// extracted by mini-css-extract-plugin
module.exports = {"searchTabs":"SearchTabs_searchTabs__6XS3F","tab":"SearchTabs_tab__iekkx","showBorder":"SearchTabs_showBorder__KWCsM","active":"SearchTabs_active__QPdx8"};